// extracted by mini-css-extract-plugin
export var actions = "PartnerSupportNewPage-module__actions___32tuH";
export var badge = "PartnerSupportNewPage-module__badge___T6hAn";
export var card = "PartnerSupportNewPage-module__card___oxpc1";
export var error = "PartnerSupportNewPage-module__error___wWhut";
export var field = "PartnerSupportNewPage-module__field___whOht";
export var header = "PartnerSupportNewPage-module__header___bX-vM";
export var hint = "PartnerSupportNewPage-module__hint___WLMju";
export var primaryButton = "PartnerSupportNewPage-module__primaryButton___DtDg3";
export var radios = "PartnerSupportNewPage-module__radios___C9qFB";
export var secondaryButton = "PartnerSupportNewPage-module__secondaryButton___GycLP";